export default __webpack_public_path__ + "static/media/hht2_ep11_book_wp_01.6df0c257.jpg";